export default __webpack_public_path__ + "static/media/Dell UltraSharp U3011 30.7a10f346.png";